import styled from 'styled-components';

export const HeaderContainer = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 6rem;
    position: fixed;
    width: 100%;
    z-index: 11111;
    color: #fff;

    @media (max-width: 1200px) {
        padding: 30px 3rem;
    }
    @media (max-width: 768px) {
        padding: 30px 1.5rem;
    }
    @media (max-width: 480px) {
        padding: 30px 1rem;
    }

    .__contact {
        font-size: 1rem;
        font-weight: 600;
        padding: 0.6rem 1.5rem;
        z-index: 11;

        @media (max-width: 768px) {
            font-size: 0.9rem;
            padding: 0.5rem 1.2rem;
}
        @media (max-width: 480px) {
            font-size: 0.8rem;
            padding: 0.4rem 1rem;
        }
    }

    img {
        height: 30px;
        z-index: 11;
    }

    button{
        z-index: 11;
    }

    .backdrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 250px;
        z-index: 10;
        pointer-events: none;
    }
`;

export const Logo = styled.div`
    cursor: pointer;
    z-index: 11;
    `;

